<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="nonindent"><span class="small">COOKING WITH JOY: THE 90/10 COOKBOOK</span>. Copyright © 2004 by Joy Bauer, M.S, R.D., C.D.N. All rights reserved. Printed in the United States of America. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="nonindent1"><a class="hlink" href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="nonindent1">Design by Leah Carlson-Stanisic</p>
<p class="nonindent1">ISBN 0-312-31253-9</p>
<p class="nonindent1">First Edition: January 2004</p>
<p class="nonindent1">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429983969_epub_cop_r1.vue?760555a1